import { PublicSurvey, Result, SubmitSurveyResponse } from "@models";
import requests from "./agent";

export const surveyService = {
  getPending: async (tenantId: number, customerId: number) => {
    try {
      const response = await requests.get<Result<PublicSurvey | null>>(
        "/api/Survey/GetPendingSurvey",
        { params: { tenantId, customerId } }
      );
      return response.result;
    } catch {
      return null;
    }
  },

  submit: async (request: SubmitSurveyResponse) => {
    await requests.post<Result<void>>("/api/Survey/Submit", request);
  },
};
